"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconDocumentEdit = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M22.55 16.43a.27.27 0 0 1-.27.27h-6.9l7.17-7.17v6.89zm34.35 21.9a1.47 1.47 0 0 0-1.47 1.47v22.47a.27.27 0 0 1-.27.28H13.57a.28.28 0 0 1-.28-.28V19.65h9a3.22 3.22 0 0 0 3.22-3.22v-9h29.64a.27.27 0 0 1 .27.28v4.64a1.47 1.47 0 1 0 2.94 0V7.73a3.22 3.22 0 0 0-3.22-3.22H24a1.47 1.47 0 0 0-1 .43L10.78 17.13a1.47 1.47 0 0 0-.43 1v44.14a3.22 3.22 0 0 0 3.22 3.22h41.58a3.22 3.22 0 0 0 3.22-3.22V39.8a1.47 1.47 0 0 0-1.47-1.47z"
  }), _react["default"].createElement("path", {
    d: "M66.15 21.43l-1.85 1.85-4.61-4.61 1.85-1.85a2 2 0 0 1 2.88 0l1.73 1.73a2 2 0 0 1 0 2.88zM32.72 47.12l3.13 3.13-4.33 1.2 1.2-4.33zm6 1.79l-4.61-4.61L57.6 20.75l4.61 4.61L38.67 48.9zm29.51-32.44l-1.73-1.73a5 5 0 0 0-7 0L45.71 28.48H21.86a1.47 1.47 0 0 0 0 2.94h20.9l-8.86 8.86h-12a1.47 1.47 0 1 0 0 2.94H31a1.47 1.47 0 0 0-.38.65l-2.27 8.19h-6.49a1.47 1.47 0 0 0 0 2.94h7.91l9.29-2.58a1.47 1.47 0 0 0 .65-.38l28.52-28.53a5 5 0 0 0 0-7z"
  })),
  height: undefined,
  width: undefined
});
IconDocumentEdit.displayName = 'IconDocumentEdit';
var _default = IconDocumentEdit;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/document-edit.js
// module id = 332
// module chunks = 0